import { useState, useEffect } from "react";
import {useParams} from "react-router-dom";
import Wallet from "../../components/user/Royalties/WalletInfo";
import PaymentHistory from "../../components/user/Royalties/PaymentHistory";
import Spinner from "../../components/UI/Spinner";
import ErrorModal from "../../components/UI/Error";
import { royaltiesService } from "../../services";

const WalletPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [royalties, setRoyalties] = useState({});

 const {id} = useParams()
const edit=id==="me" ? false : true
  useEffect(() => {
    const fetchWalletData = async () => {
      setError(false);
      try {
        const {
          totalEarnings,
          balance,
          totalPayments,
          transactions,
          ...wallet
        } = await royaltiesService.getArtisteRoyaltiesAccount(id||"me");
        const toThreshold = 40000 - balance;

        setRoyalties({
          balance,
          totalEarnings,
          totalPayments,
          toThreshold,
          accountInfo:{
            accountName: wallet.accountName || "N/A",
            accountNumber: wallet.accountNumber || "0000000000",
            bankName: wallet.bankName || "N/A Bank",
          }
        });

        // Simulated payment history
        const myPaymentHistory = [
        ];

        setPaymentHistory(myPaymentHistory);
      } catch (err) {
        console.error(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchWalletData();
  }, []);

  if (loading)
    return (
      <div className="grid place-content-center h-[60vh]">
        <Spinner />
      </div>
    );

  if (error)
    return (
      <ErrorModal
        isOpen={error}
        onClose={() => setError(false)}
        title={"Error Fetching Wallet"}
        message={
          "There was a problem fetching your wallet details. Please check your internet connection and try again."
        }
      />
    );
  return (
    <div className="min-h-screen bg-gray-100 text-white p-6">
      <div className="max-w-5xl mx-auto">
        <Wallet royalties={royalties} showEdit={edit}/>
        <PaymentHistory paymentHistory={paymentHistory} />
      </div>
    </div>
  );
};

export default WalletPage;